/**
 * TRAD-3701 — «이 경로의 화면 제목» 등록소(순수 모듈 상태 + 구독).
 *
 * 왜 필요한가: PageMeta 는 react-helmet-async 로 제목을 «커밋 뒤 비동기»로 바꾼다. 페이지 뷰 트래커가 위치 변경
 * effect 에서 `document.title` 을 읽으면 «이전 화면» 제목이 찍힌다(2026-10-13 dev 실측: /market 이동 → dt=홈 제목,
 * /portfolio 이동 → dt=BTC 상세 제목). 그래서 PageMeta 가 «어느 경로(pathname+search)의 제목인지»를 같이 알리고,
 * 트래커는 현재 경로와 맞는 제목만 쓴다.
 */
export interface PublishedPageTitle {
  path: string;
  title: string;
}

type Listener = (entry: PublishedPageTitle) => void;

let last: PublishedPageTitle | null = null;
const listeners = new Set<Listener>();

export const publishPageTitle = (path: string, title: string): void => {
  last = { path, title };
  listeners.forEach(listener => listener({ path, title }));
};

/** 가장 최근에 알린 제목(트래커가 구독하기 «전»에 PageMeta effect 가 먼저 돈 경우를 위해). */
export const getLastPublishedPageTitle = (): PublishedPageTitle | null => last;

export const subscribePageTitle = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** 테스트 전용 — 모듈 상태 초기화. */
export const __resetPageTitleRegistryForTest = (): void => {
  last = null;
  listeners.clear();
};
